import UserRoles from 'clay-commons/enum/user-roles';

import RootPage from '.';

const routes = [
  {
    path: '/assistant',
    component: RootPage,
    roles: [UserRoles.ADMIN],
  },
];

export default routes;
